<template lang="pug">
  .gallery-wrapper
    .gallery-text
      .gallery-text__center
        img(src="@/assets/images/beyond-image-carrot.svg", alt="Instacart logo gallery" width="80" height="79")
        h3 Beyond the Cart:
        p A Year of Essential Stories
    .gallery-drag
      img(src="@/assets/images/icon-drag-gallery.svg", alt="Draggable Gallery" width="50" height="41")
      p Drag from left to right 
    .gallery-desktop(v-if="!isMobile")
      .gallery-desktop__travel(ref="galleryTravel")
        .gallery-desktop__list(v-for="(shopper, key) in dataShoppers" :key="key" :id='shopper["-id"]' :data-item="key+1" @click="getDescription($event)")
          .gallery-desktop__text
            p.title {{ shopper["-title"] }} 
            p {{ shopper["-location"] }}
            //p {{ shopper["-shopper"] }}
          .gallery-mobile__image
            //img( :src='shopper["-image"]' :alt='shopper["-id"]')
            img( v-lazy='shopper["-image"]' :src='shopper["-image"]' :alt='shopper["-id"]' width="396" height="396")
            
          //.gallery-desktop__container1
            .gallery-desktop__list(v-for="(shopper, key) in dataShoppers" :key="key" :id='shopper["-id"]' :data-item="key+1" @click="getDescription($event)" v-if="key == 0 || key == 1 || key == 2 || key == 3 || key == 4")
              .gallery-desktop__text
                p.title {{ shopper["-title"] }} 
                p {{ shopper["-location"] }}
                p {{ shopper["-shopper"] }}
              .gallery-mobile__image
                img( :src='shopper["-image"]', alt="")
          //.gallery-desktop__container2
            .gallery-desktop__list(v-for="(shopper, key) in dataShoppers" :key="key" :id='shopper["-id"]' :data-item="key+1" @click="getDescription($event)" v-if="key == 5 || key == 6")
              .gallery-desktop__text
                p.title {{ shopper["-title"] }} 
                p {{ shopper["-location"] }}
                p {{ shopper["-shopper"] }}
              .gallery-mobile__image
                img( :src='shopper["-image"]', alt="")
          //.gallery-desktop__container3
            .gallery-desktop__list(v-for="(shopper, key) in dataShoppers" :key="key" :id='shopper["-id"]' :data-item="key+1" @click="getDescription($event)" v-if="key == 7 || key == 8")
              .gallery-desktop__text
                p.title {{ shopper["-title"] }} 
                p {{ shopper["-location"] }}
                p {{ shopper["-shopper"] }}
              .gallery-mobile__image
                img( :src='shopper["-image"]', alt="")
        
    .gallery-mobile(v-if="isMobile")
      slick(
        ref="slick"
        :options="slickOptions"
        @afterChange="handleAfterChange"
        @beforeChange="handleBeforeChange"
        )
        .gallery-mobile__item(v-for="(shopper, key) in dataShoppers" :key="key" :id='shopper["-id"]' @click="getDescription($event)")
          .gallery-mobile__text
            p.title {{ shopper["-title"] }} 
            p {{ shopper["-location"] }}
            //p {{ shopper["-shopper"] }}
          .gallery-mobile__image
            img( v-lazy='shopper["-imageMobile"]' :alt='shopper["-id"]')
            //img( :src='shopper["-imageMobile"]', alt='shopper["-id"]')

    
</template>
<script>

  import isMobile from 'mobile-device-detect'
  import Slick from 'vue-slick';
  import 'slick-carousel/slick/slick.css';
  import { gsap } from 'gsap'
  import { Draggable } from 'gsap/Draggable' 
  import { InertiaPlugin } from 'gsap/InertiaPlugin' 
  import instacartMap from "../assets/instacartMap"
  
  gsap.registerPlugin(Draggable);
  gsap.registerPlugin(InertiaPlugin);

  export default{
    data: function () {
        return {
            isMobile: isMobile.isMobile,
            dataShoppers: instacartMap.g.path,
            canShow: false,
            widthCarousel: 0,
            slickOptions: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,  
                dots: false,
                arrows: false,
                centerMode: true,
                centerPadding: '30px',
                responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll:3,
                  }
                },
                {
                  breakpoint: 560,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll:2,
                  }
                },
                {
                  breakpoint: 440,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll:1,
                  }
                },
              ]
            },
        }
    },
    components:{
      Slick
    },
    mounted: function(){
      gsap.to('.gallery-wrapper', 0, {alpha:0});
      this.$nextTick(() => {
        setTimeout(() =>{
          this.$root.$refs.descriptions.hideLoading();
          if(!this.isMobile) this.initGalleryDesktop();
          gsap.to('.gallery-wrapper', 1.0, {alpha:1});
        }, 1000);
      });
      
    },
    computed:{

    },
    methods: {
        initGalleryDesktop(){
          const vue = this;
          Draggable.create(".gallery-desktop__travel", {
            type: "x",
            edgeResistance: 0.5,
            snap: (val) => Math.round(val / 100) * 100,
            inertia: true,
            allowContextMenu : true,  
            onThrowComplete : function() { console.log(this.x) },
            bounds: {
              minX: -document.querySelector(".gallery-desktop__travel").offsetWidth + document.querySelector(".gallery-desktop").offsetWidth,
              maxX: 0
            },
            onDrag: function() {
              vue.hideDragImage();  
            }
          });
          if(isMobile.deviceType != 'mobile') vue.$refs.galleryTravel.classList.add('loaded');
        
        },
        handleAfterChange() {
            this.showDescription();
        },
        handleBeforeChange() {
            this.hideDescription();
            if(isMobile.deviceType == 'mobile')  this.hideDragImage();  
        },
        hideDragImage(){
          const tl = gsap.timeline();
          tl.to('.gallery-drag', 1, {alpha: 0});
          tl.to('.gallery-drag', {display:'none'}, "1");
        },
        showDescription(){
          setTimeout(() =>{
            let slide = document.querySelector(".slick-slide.slick-current.slick-active .gallery-mobile__text");
            gsap.to(slide, 1, {alpha:1});
          }, 2000);
        },
        hideDescription(){
          gsap.to(".gallery-mobile__text", {alpha: 0});
        },
        getDescription(event){
          let targetId = event.currentTarget.id;
          this.$root.$refs.descriptions.getDescription(targetId, 'gallery');
        }
    }
  }
</script>
<style lang="scss">
  .gallery{
    position: absolute;
    display: block;
    background-color: #f7f0e4;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: -1;
    pointer-events: none;
    table-layout: fixed;
    &.showing{
      z-index: 5;
      pointer-events: auto;
    }
    &-mobile{
       
    }
    &-desktop{
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      overflow: hidden;
      padding-top: 120px;
      &__container{
        width: 100%;
        will-change: transform;
      }
      &__travel{
        will-change: transform;
        width: 8200px;
        display: inline-flex;
        justify-content: space-between;
        height: 100%;
        position: relative;
        &.loaded{
          .gallery-desktop__list{
            @include animation(hideShow 0.4s cubic-bezier(0.175, 0.885, 0.320, 1.275) both);
            @for $i from 1 through 60 {
              &:nth-child(#{$i}){
                animation-delay: #{$i * 0.04}s;
              }
            }
          }  
        }  
      }
      &__list{
        overflow: hidden;
        width: 300px;
        height: auto;
        display: block;
        cursor: pointer;
        border-radius: 30px;
        border: 2px solid $orange;
        position: relative;
        @include box-shadow(20px,20px,40px,rgba(11, 96, 72, 0.15),false);
        flex-grow: 0;
        flex-shrink: 0;
        opacity: 0;
        img{
          width: 100%;
          height: auto;
          display: block;  
        }
        &:hover{
          z-index: 10 !important;
          .gallery-desktop__text{
            opacity: 1;
          }
        }
        @for $i from 1 through 9 {
          @if $i == 1{
            @for $j from 0 through 8 {
              &:nth-child(#{$i + ($j * 9)}){
                width: 300px;
                height: 300px;
                transform: translateX(#{15 - (45 * $j)}px);
              } 
            }
             
          }
          @if $i == 2{
            @for $j from 0 through 8 {
              &:nth-child(#{$i + ($j * 9)}){
                width: 150px;
                height: 150px;
                z-index: 2;
                transform: translateX(#{-20 - (45 * $j)}px);
                margin-top: -2vh;
              }
            }    
          }
          @if $i == 3{
            @for $j from 0 through 8 {
              &:nth-child(#{$i + ($j * 9)}){
                width: 150px;
                height: 150px;
                z-index: 3;
                transform: translateX(#{-30 - (45 * $j)}px);
                margin-top:10vh;
              }
            }
          }
          @if $i == 4{
            @for $j from 0 through 8 {
              &:nth-child(#{$i + ($j * 9)}){
                width: 400px;
                height: 400px;
                z-index: 6;
                transform: translateX(-45vw);
                transform: translateX(#{-45 - (45 * $j)}px);
                margin-top:2vh;
              }
            }
          }
          @if $i == 5{
            @for $j from 0 through 8 {
              
              &:nth-child(#{$i + ($j * 9)}){
                width: 240px;
                height: 240px;
                z-index: 5;
                transform: translateX(#{-46 - (45 * $j)}px);
                margin-top:4vh;
              }
            }
          }
          @if $i == 6{
            @for $j from 0 through 8 {
              &:nth-child(#{$i + ($j * 9)}){
                width: 150px;
                height: 150px;
                z-index: 3;
                //transform: translateX(calc(20px + #{86 * $j}vw));
                transform: translateX(calc(20px + #{1200 * $j}px));

                margin-top:40vh;
                position: absolute;
              }
            }
          }
          @if $i == 7{
            @for $j from 0 through 8 {
              
              &:nth-child(#{$i + ($j * 9)}){
                width: 150px;
                height: 150px;
                z-index: 3;
                //transform: translateX(calc(190px + #{86 * $j}vw));
                transform: translateX(calc(190px + #{1200 * $j}px));

                margin-top:42vh;
                position: absolute;
              }
            }
          }
          @if $i == 8{
            @for $j from 0 through 8 {  
              &:nth-child(#{$i + ($j * 9)}){
                width: 300px;
                height: 300px;
                z-index: 5;
                //transform: translateX(calc(300px + #{86 * $j}vw));
                transform: translateX(calc(300px + #{1200 * $j}px));

                margin-top:30vh;
                position: absolute;
              }
            }
          }
          @if $i == 9{
            @for $j from 0 through 8 {
              &:nth-child(#{$i + ($j * 9)}){
                width: 240px;
                height: 240px;
                z-index: 5;
                //transform: translateX(calc(970px + #{86 * $j}vw));
                transform: translateX(calc(970px + #{1200 * $j}px));
                margin-top:40vh;
                position: absolute;
              }
            }
          }
          &:nth-child(59){
            width: 300px;
            height: 300px;
            z-index: 5;
            transform: translateX(calc(300px + 7200px));
            margin-top: 30vh;
            position: absolute;
          }
        }
        
          
      }
      &__text{
        position: absolute;
        width: 100%;
        height: 100%;
        background: rgba($black,0.5);
        display: flex;
        justify-content: center;
        flex-flow: column;
        padding: 1rem;
        z-index: 2;
        opacity: 0;
        @include transition(all 0.5s ease 0s);
        p{
          color: $white;
          text-align: center;
          font-size: 0.875rem;
          line-height: 1.2;
          margin: 0;
          &.title{
            font-weight: 900;
            font-size: 1.2rem;
          }
        }
      }
    }
    &-text{
      position: relative;
      width: 100%;
      height: auto;
      margin-top: 30px;
      padding: 0 2rem;
      display: flex;
      justify-content: center;
      z-index: 3;
      @include respond-to('mobile'){
        margin-top: 10px;
      }
      &__center{
        position: relative;
        img{
          position: absolute;
          left: -25px;
          top: 0;
          width: 60px;
          @include respond-to('mobile'){
            left: -50px;
            width: 80px;
          }
        }      
        h3{
          color: $green;
          font-weight: 900;
          margin: 0;
          @include respond-to('small'){
            font-size: 2.5rem;
          }
        }
        p{
          text-align: center;
          color: $orange;
          margin: 0;
          font-weight: 900;
        }
      }
    }
    &-drag{
      position: absolute;
      width: 160px;
      height: auto;
      left: 50%;
      transform: translate(-50%, 0);
      bottom: 5rem;
      @include respond-to('small'){        
        bottom: 3.5rem;
      }
      @media (min-width: 768px) and (max-width: 1024px) {
        bottom: 2rem;
      }
      img{
        margin: 0 auto;
        display: block;
        width: 50px;
        height: auto;
      }
      p{
        color: $soft_green;
        font-size: 0.75rem;
        margin: 0;
        text-align: center;
      }
    }
    &-mobile{
      position: relative;
      display:block;
      width: 100%;
      height: auto;
      padding-top:0.5rem;
      @media (min-width: 768px) and (max-width: 1024px) {
        height: calc(100vh - 180px);
        display: flex;
        flex-flow: column;
        justify-content: center;
      } 
      .slick-slide{
        padding: 0 0.5rem;
      }
      &__item{
        position: relative;
        width: 100%;
        height: calc(100vh - 57px - 3rem - 59px - 31px - 75px);
        @include respond-to('mobile'){ 
          height: calc(75vh - 57px - 3rem - 59px - 31px - 75px);
        }
        @media (min-width: 768px) and (max-width: 1024px) {
          height: calc(100vh - 57px - 3rem - 59px - 31px - 75px);
        }
        display: block;
        border-radius: 40px;
        overflow: hidden;
      }
      &__text{
        position: absolute;
        width: 100%;
        height: 100%;
        background: rgba($black,0.5);
        display: flex;
        justify-content: center;
        flex-flow: column;
        padding: 1rem;
        z-index: 2;
        opacity: 0;
        p{
          color: $white;
          text-align: center;
          font-size: 0.875rem;
          margin: 0;
          &.title{
            font-weight: 900;
            font-size: 1.5rem,
          }
        }
      }
      &__image{
        width: 100%;
        height: 100%;
        position: relative;
        overflow: hidden;
        img{
          width: 100%;
          height: 100%;
          display: block;
          object-fit: cover;
          &[lazy="loading"]{
            width: 50px !important;
            margin: auto;
            object-fit: contain;
          }
        }
      }
    }
  }
  
  /* ----------------------------------------------
   * Generated by Animista on 2021-3-18 18:16:36
   * Licensed under FreeBSD License.
   * See http://animista.net/license for more info. 
   * w: http://animista.net, t: @cssanimista
   * ---------------------------------------------- */

  /**
   * ----------------------------------------
   * animation swing-in-top-fwd
   * ----------------------------------------
   */
   @include keyframes(hideShow) {
     0% {
       opacity: 0;
       left: -10px;
     }
     100% {
       opacity: 1;
       left: 0;
     }
   }

</style>
